import hudPresetTable from "../../../data/tables/ui/huds/infinite-war.json";
import { getUiLayout } from "../../layout";
import type { HudShellHandle } from "../../layout/hud-shell";
import type { UiHudPreset } from "../../layout/types";
import { topHtml } from "./markup";
import { clearMenuModal, renderMenuModal } from "./menu";
import type {
  InfiniteWarHudHandlers,
  InfiniteWarHudMode,
  InfiniteWarHudSnap,
} from "./types";

export type {
  InfiniteWarHudHandlers,
  InfiniteWarHudMode,
  InfiniteWarHudSnap,
} from "./types";

const preset = hudPresetTable as UiHudPreset;

export function mountInfiniteWarHud(handlers: InfiniteWarHudHandlers): {
  sync: (snap: InfiniteWarHudSnap) => void;
  destroy: () => void;
} {
  const ui = getUiLayout();
  ui.sync();
  const shell: HudShellHandle = ui.mountShell(preset);

  const top = shell.region("top");
  top.style.pointerEvents = "auto";
  top.innerHTML = topHtml();

  const mid = shell.region("mid");
  mid.style.pointerEvents = "none";
  mid.innerHTML = "";

  const bottom = shell.region("bottom");
  bottom.style.pointerEvents = "none";
  bottom.innerHTML = "";

  const modal = shell.region("modal");
  clearMenuModal(modal);
  let lastMode: InfiniteWarHudMode | null = null;

  top.querySelector("[data-menu]")?.addEventListener("click", (ev) => {
    ev.stopPropagation();
    handlers.onOpenMenu();
  });

  return {
    sync(snap) {
      ui.sync();
      const menuBtn = top.querySelector("[data-menu]") as HTMLButtonElement | null;
      if (menuBtn) {
        menuBtn.disabled = snap.mode === "ended";
        menuBtn.hidden = snap.mode === "ended";
      }

      if (snap.mode === "play") {
        if (lastMode !== "play") {
          lastMode = "play";
          clearMenuModal(modal);
        }
        return;
      }

      if (lastMode === snap.mode) return;
      lastMode = snap.mode;
      renderMenuModal(modal, snap.mode, snap.winner, handlers);
    },
    destroy() {
      shell.destroy();
    },
  };
}
